import { logEvent } from "@src/appV2/lib/analytics";
import { Badge, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { IconButton } from "../../components/IconButton";
import { IN_HOME_USER_EVENTS } from "../lib/events";
import { useVisitFiltersContext } from "./useVisitFiltersContext";

interface VisitFilterButtonProps {
  modalState: UseModalState;
}

export function VisitFilterButton(props: VisitFilterButtonProps) {
  const { modalState } = props;
  const { appliedFiltersCount } = useVisitFiltersContext();

  return (
    <Badge
      count={appliedFiltersCount}
      overlap="circular"
      color="primary"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <IconButton
        variant="outlinedHeavy"
        aria-label="Open Filters Button"
        size="small"
        iconType="slider-settings"
        isSelected={appliedFiltersCount > 0}
        sx={{ boxShadow: "none !important" }}
        onClick={() => {
          logEvent(IN_HOME_USER_EVENTS.FILTERS_OPENED);
          modalState.openModal();
        }}
      />
    </Badge>
  );
}
